import Raven from '../Raven';

export const sendFeedback = data => {
    const result = Raven.post(
        'unishop-fn-misc/feedback',
        data,
        { 'headers': { 'Content-Type': 'application/json' } }
    )

    return result
}

export const validateEnrollSponser = (market, enrollerID, sponsorID) => {
    console.log('VALIDATE!', enrollerID, sponsorID)
    const result = Raven.post(
        'unishop-fn-misc/validator/enroller_sponsor',
        {
            market: market,
            enrollerId: enrollerID,
            sponsorId: sponsorID
        },
        { 'headers': { 'Content-Type': 'application/json' } }
    )

    return result
}